module.exports = __webpack_public_path__ + "img/6-itol-root.dde47ce9.png";